module.exports = __webpack_public_path__ + "static/media/online-booking-img.f21ab5dc.jpg";